export default "__VITE_PUBLIC_ASSET__0fc48ac6__"